module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "relationships"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.fkHeliumContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.fkJourneyContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "user-helium"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userHeliumContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userJourneyContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "user-journey"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userHeliumV2Content,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userJourneyV2Content,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Guide")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#guide"
    }
  }, [_vm._v("Guide")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#relationships"
    }
  }, [_vm._v("Relationships")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#user-helium"
    }
  }, [_vm._v("Single device per user")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#user-journey"
    }
  }, [_vm._v("Multiple devices per user")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane active show",
    attrs: {
      "id": "guide"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('legend', [_vm._v("Introduction:")]), _vm._v(" "), _c('p', [_vm._v("The Helium Journey middleware provides bidirectional data synchronisation between a Helium app's database and a Journey app's database. See the other tabs for code examples.")]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Data model:")]), _vm._v(" "), _c('p', [_vm._v("In order to facilitate data sync between the two platforms the Helium Journey middleware requires the data model of the Helium and Joureny app to match. Persistent objects declared must exist the same on both sides such as the object name, attributes and relationship names.")]), _vm._v(" "), _c('legend', [_vm._v("Primitive Data Types:")]), _vm._v(" "), _c('p', [_vm._v("The data models declared for an integrated Helium Journey application, for the objects that are to be synchronised, must be exactly the same and of equivalent types.")]), _vm._v(" "), _c('p', [_vm._v("Supported Data Types:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Whole number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Textual value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Floating point number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Boolean value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date and time value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Photo value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Signature value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Attachment value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Helium")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("decimal")]), _vm._v(" "), _c('td', [_vm._v("bool")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("datetime")]), _vm._v(" "), _c('td', [_vm._v("blob")]), _vm._v(" "), _c('td', [_vm._v("blob")]), _vm._v(" "), _c('td', [_vm._v("blob")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('td', [_vm._v("integer")]), _vm._v(" "), _c('td', [_vm._v("text")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("datetime")]), _vm._v(" "), _c('td', [_vm._v("photo")]), _vm._v(" "), _c('td', [_vm._v("signature")]), _vm._v(" "), _c('td', [_vm._v("attachment")])])])]), _vm._v(" "), _c('p', [_vm._v("Unsupported Data Types:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Void")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Single Choice")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Single Choice Integer")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Multiple Choice")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Multiple Choice Integer")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Tracker")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Helium")]), _vm._v(" "), _c('td', [_vm._v("void (as method return type only)")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("location")]), _vm._v(" "), _c('td', [_vm._v("single-choice")]), _vm._v(" "), _c('td', [_vm._v("single-choice-integer")]), _vm._v(" "), _c('td', [_vm._v("multiple-choice")]), _vm._v(" "), _c('td', [_vm._v("multiple-choice-integer")]), _vm._v(" "), _c('td', [_vm._v("track")])])])]), _vm._v(" "), _c('p', [_vm._v("The unsupported data types on Joureny may be used however only in the context of the view javascript and when using the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")])]), _vm._v(" "), _c('legend', [_vm._v("Enums:")]), _vm._v(" "), _c('p', [_vm._v("Helium and Journey handle enum types differently and due to this a Journey enum is not directly compatable with a Helium enum. Enums can however be used in an integrated application by using enums only on Helium. On Journey use the datatype type text, values persisted in the text format on Journey need to be a valid enum value as declared on the Helium model.")]), _vm._v(" "), _c('p', [_vm._v("Journey enums can be used on the Journey app as long as they are used only in the view javascript or when using the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")])]), _vm._v(" "), _c('legend', [_vm._v("Relationships:")]), _vm._v(" "), _c('p', [_vm._v("OneToOne and ManyToOne relationships are supported provided the relationship names are matching on Helium and Journey.")]), _vm._v(" "), _c('p', [_vm._v("ManyToMany and OneToOne relationships are not supported on Journey and are therefore objects using these annotations should also be skipped from syncing by also adding the @NotTracked annotation to the persistent object")]), _vm._v(" "), _c('legend', [_vm._v("Ignoring Certain Objects:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("To skip an object from being processed from Helium to Journey the "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Data+Types#DataTypes-@NotTracked"
    }
  }, [_vm._v("@NotTracked annotation")]), _vm._v(" can be used.")]), _vm._v(" "), _c('li', [_vm._v("To skip an object from being processed from Journey to Helium the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")]), _vm._v(" feature can be used.")]), _vm._v(" "), _c('li', [_vm._v("If for some reason the annotation or LocalDB cannot be used objects can be specifically skipped on the integration configuration.")]), _vm._v(" "), _c('li', [_vm._v("When an object is halting integration because it cannot be synced to either Helium or Journey then it's type can be explicilty skipped until sync has advanced past that version")])]), _vm._v(" "), _c('legend', [_vm._v("Special Attribute Names:")]), _vm._v("\n            If for some reason on Journey side someone has defined an attribute name that is reserved on Helium, an alternative attribute name must be used on both Helium and Journey.\n            "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Reserved attribute / column name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Recommended naming on both Helium and Journey")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("creation_date")])])])]), _vm._v(" "), _c('legend', [_vm._v("Attribute names ending in \"_id\"")]), _vm._v(" "), _c('p', [_vm._v("Do not create attributes on Helium ending in \"_id\".  This is seen as a relationship on Journey's side.")]), _vm._v(" "), _c('legend', [_vm._v("Object names in CAPS")]), _vm._v(" "), _c('p', [_vm._v("Do not use Journey object names in all CAPS.  It will not be handled correctly on Helium's side.")]), _vm._v(" "), _c('legend', [_vm._v("Cascade in relationships")]), _vm._v(" "), _c('p', [_vm._v("When you delete an object on Journey, and some other object depends on it (in a many-to-one relationship), then Journey has a cascade policy and will subsequently nullify the other object's owner reference. Helium as of 1.3.5 also has a \"on cascade set null\" policy. As an example, if you have a Farmer object with a many to one relationship to a Country object e.g. South Africa.  If the country South Africa gets deleted, then the country_id gets set to null on Journey, and likewise the column country_fk gets set to null on Helium")]), _vm._v(" "), _c('legend', [_vm._v("Resources:")]), _vm._v(" "), _c('p', [_vm._v("See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Data+Types"
    }
  }, [_vm._v("Helium data type docs")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#section-field-types"
    }
  }, [_vm._v("Journey data type docs")]), _vm._v(" for more info data types.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d1dd1da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SyncGuide.vue
// module id = 589
// module chunks = 2